module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/e6ed36fccdd208479cacfbec1a64ac4b.png";